import Siema from 'siema'
blue.ready('cardSlider', '.cardSlider', container => {
	const slider = container.querySelector('.cardSlider-slider')
	const prev = container.querySelector('.cardSlider-prev')
	const next = container.querySelector('.cardSlider-next')
	let cards = [...slider.querySelectorAll('.card')]

	if(cards.length > 0){
		let lgPageSize = 3
		let mdPageSize = 2
		let smPageSize = 1

		if(lgPageSize > cards.length)
			lgPageSize = cards.length

		if(mdPageSize > cards.length)
			mdPageSize = cards.length
		
		if(smPageSize > cards.length)
			smPageSize = cards.length

		const opts = {
			selector: slider,
			easing: 'ease',
			duration: 500,
			perPage: {
				0: smPageSize,
				900: mdPageSize,
				1250: lgPageSize
			},
			loop: true,
			onInit: () => {
				cards = [...slider.querySelectorAll('.card')]
				cards.forEach(card => card.removeAttribute('id'))
			}
		}

		const	slide = new Siema(opts)

		prev.addEventListener('click', () => slide.prev())
		next.addEventListener('click', () => slide.next())
	}
})